// 授業のエンティティ
export class Lessons {
  // 授業ID DB型(*autokey)
  public class_id?: number;
  // 先生ユーザーID DB型(*fk)
  public teacher_user_id?: string;
  // 生徒ユーザーID DB型(*fk)
  public student_user_id?: string;
  // 状態 DB型(varchar(36))
  public reservation_state?: string;
  // 開始日時 DB型(DATETIME)
  public start_dt?: Date;
  // 終了日時 DB型(DATETIME)
  public end_dt?: Date;
  // 予約登録日時 DB型(DATETIME)
  public reservation_date?: Date;
  // 週予約 DB型(*flg)
  public reservation_day_of_week?: boolean;
  // おすすめられ度 DB型(*flg)
  public matching_weight?: boolean;
  // キャンセル理由 DB型(MEDIUMTEXT)
  public cancelreason?: string;
  // キャンセル日時 DB型(DATETIME)
  public cancel_dt?: Date;
  // 振り返られ DB型(*flg)
  public is_transferred?: boolean;
  // 生徒が日報みたか？(非推奨) DB型(*flg)
  public hidden_dashboard?: boolean;
  // 日報既読か？ DB型(*flg)
  public is_read_yet?: boolean;
  // 先生の一言コメント(不使用) DB型(*varchar512)
  public one_comment?: string;
  // 確定授業料 DB型(DOUBLE)
  public lesson_amount?: any;
  // 生徒へのリマインド DB型(*flg)
  public did_student_remind?: boolean;
  // 日報未提出リマインド DB型(*flg)
  public did_report_remind?: boolean;
  // 先生のシフトID DB型(*autokeyFk)
  public shift_table_id?: number;
  static fromDB(record: { [column: string]: any; [column: number]: any }): Lessons {
    const entity = new Lessons();
    entity.class_id = record['class_id'];
    entity.teacher_user_id = record['teacher_user_id'];
    entity.student_user_id = record['student_user_id'];
    entity.reservation_state = record['reservation_state'];
    entity.start_dt = record['start_dt'];
    entity.end_dt = record['end_dt'];
    entity.reservation_date = record['reservation_date'];
    entity.reservation_day_of_week = record['reservation_day_of_week'];
    entity.matching_weight = record['matching_weight'];
    entity.cancelreason = record['cancelreason'];
    entity.cancel_dt = record['cancel_dt'];
    entity.is_transferred = record['is_transferred'];
    entity.hidden_dashboard = record['hidden_dashboard'];
    entity.is_read_yet = record['is_read_yet'];
    entity.one_comment = record['one_comment'];
    entity.lesson_amount = record['lesson_amount'];
    entity.did_student_remind = record['did_student_remind'];
    entity.did_report_remind = record['did_report_remind'];
    entity.shift_table_id = record['shift_table_id'];
    return entity;
  }
  static getTypeFitEntity(value: any): Lessons {
    const entity = new Lessons();
    entity.class_id = value.class_id;
    entity.teacher_user_id = value.teacher_user_id;
    entity.student_user_id = value.student_user_id;
    entity.reservation_state = value.reservation_state;
    entity.start_dt = value.start_dt;
    entity.end_dt = value.end_dt;
    entity.reservation_date = value.reservation_date;
    entity.reservation_day_of_week = value.reservation_day_of_week;
    entity.matching_weight = value.matching_weight;
    entity.cancelreason = value.cancelreason;
    entity.cancel_dt = value.cancel_dt;
    entity.is_transferred = value.is_transferred;
    entity.hidden_dashboard = value.hidden_dashboard;
    entity.is_read_yet = value.is_read_yet;
    entity.one_comment = value.one_comment;
    entity.lesson_amount = value.lesson_amount;
    entity.did_student_remind = value.did_student_remind;
    entity.did_report_remind = value.did_report_remind;
    entity.shift_table_id = value.shift_table_id;
    return entity;
  }
}
